import { createFileRoute, redirect } from '@tanstack/react-router';

import { meQueryOptions } from '../../../../api/me';

/**
 * The photo and its moderation state are cards on the person's page now, beside
 * the account they belong to. Redirect rather than delete: this was the landing
 * page after signing in, so the URL is in every history.
 */
export const Route = createFileRoute('/_auth/photos/me/')({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.query({
      ...meQueryOptions(),
      staleTime: 'static',
    });
    throw redirect({ to: '/users/$oid', params: { oid: me.oid } });
  },
});
